var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDarEdit = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 21,
  viewBox: "0 0 20 21",
  fill: "none",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.24141 17.375H3.75C3.58424 17.375 3.42527 17.3091 3.30806 17.1919C3.19085 17.0747 3.125 16.9157 3.125 16.75V13.2586C3.12508 13.093 3.19082 12.9343 3.30781 12.8172L12.9422 3.18279C13.0594 3.06567 13.2183 2.99988 13.384 2.99988C13.5497 2.99988 13.7086 3.06567 13.8258 3.18279L17.3172 6.67185C17.4343 6.78905 17.5001 6.94796 17.5001 7.11365C17.5001 7.27934 17.4343 7.43825 17.3172 7.55545L7.68281 17.1922C7.56569 17.3092 7.40695 17.3749 7.24141 17.375Z",
  stroke: "#6B5CE8",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.625 5.5L15 9.875",
  stroke: "#6B5CE8",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgDarEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/dar_edit.0a54751f3c5f535e6338f7b07ba1db30.svg";